import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import styles from './home.module.scss';
import BackgroundImage from '../../assets/home/backgroundimage.png';
import CreateProgram from '../../assets/home/createprogram.png';
import TitleComponent from '../../components/title/title.component';
import Loader from '../../components/Loader';
import { useGetProgramsList } from '../../services';
import { useUserStore } from '../../store';

const HomePage = ({ history }) => {
  const [button2, setButton2] = useState('');
  const [button1, setButton1] = useState('');
  const [button1Link, setButton1Link] = useState('');
  const [button2Link, setButton2Link] = useState('');

  const user = useUserStore((s) => s.user);
  const query = useGetProgramsList();
  useEffect(() => {
    const programsLength = localStorage.getItem('programsLength');

    if (programsLength) {
      if (programsLength > 0) return history.push('/my-programs');
    }

    if (user.is_Certified) {
      localStorage.setItem('isCertified', true);
      if (!query.isLoading) {
        if (query.data?.data.result.length > 0) {
          localStorage.setItem('programsLength', query.data?.data.result.length);
          return history.push('/my-programs');
        }
      }
      setButton1('Create Program');
      setButton1Link('create');
      setButton2('Demo Game');
      setButton2Link('demo');

      // not defined so redirecting to index page
    } else {
      localStorage.setItem('isCertified', false);
      setButton1('Continue Certification');
      setButton1Link('continue');

      setButton2('Host Game');
      setButton2Link('host');
    }
    return null;
  }, [user, query]);

  const onCreateClick = () => {
    history.push('/design/add/new');
  };
  const onContinueCertification = () => {
    window.open(`https://app.eduflow.com/join/${user.certificationCode}`, '_blank');
  };
  const onHostClick = () => {
    window.open('http://game.evivve.com/', '_blank');
  };

  const onDemoClick = () => {
    history.push('/demo');
  };

  return (
    <>
      {query.isLoading && <Loader />}
      <div className="container">
        <div className={`w-75 pt-3 ${styles.title}`}>
          <TitleComponent title="Home" />
        </div>
        <div className="row align-items-center my-5">
          <div className="img col-lg-6 col-md-6 col-12 w-50">
            <img src={BackgroundImage} alt="background" className="img-fluid" />
          </div>
          <div className="col-lg-6 col-md-6 col-12 w-50">
            <p style={{ lineHeight: 0 }} className="ml-3">
              <strong>You haven’t designed any</strong>
            </p>
            <p>
              <strong>programs yet, get started here</strong>
            </p>

            <div className="col">
              <button
                type="button"
                onClick={button1Link === 'create' ? onCreateClick : onContinueCertification}
                className={`btn btn-secondary ${styles['home-button']}`}>
                <img
                  src={CreateProgram}
                  alt="Create-Program"
                  className="mr-1"
                  // height="13px"
                  // width="13px"
                />
                {button1}
              </button>
            </div>
            <div className="col">
              <button
                type="button"
                onClick={button2Link === 'demo' ? onDemoClick : onHostClick}
                className={`btn btn-primary mt-3 ${styles['home-button']}`}>
                {button2}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

HomePage.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

export default HomePage;
